import { useState, useEffect } from "react";

interface User { id: string; name: string; email: string; image?: string; }
export interface Session { user: User; expires: string; }

export function useSession() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);
  useEffect(() => {
    fetch("/api/auth/session")
      .then(r => r.ok ? r.json() : null)
      .then(data => setSession((data as Session)?.user ? (data as Session) : null))
      .catch(() => setSession(null));
  }, []);
  return { session, isLoading: session === undefined };
}
